import { DataMapperConfig } from 'ihub/common';
import { AdvancedTourStep } from '../shared-types';
import { TaskTourProps } from './task-tour-props';

export function getDataMapperTourSteps({
	defaultStyles,
	microTaskConfigType,
}: Readonly<TaskTourProps>): AdvancedTourStep[] {
	if (!microTaskConfigType) return [];
	const config = microTaskConfigType as DataMapperConfig;

	const getTransformationSteps = (): AdvancedTourStep[] => {
		if (config.transformations.length === 0) return [];
		return [
			{
				id: 'mapper-node',
				selector: '[data-tour="mapper-node"]',
				content:
					'This is what the nodes look like once a property has been added on to the mapper grid.',
			},
			{
				id: 'mapper-node-delete',
				selector: '[data-tour="mapper-node-delete"]',
				content: 'The nodes can also be removed by clicking on the "X" on the nodes themselves.',
			},
			{
				id: 'mapper-node-destination',
				selector: '[data-tour="mapper-node-destination"]',
				content: 'Add a destination node for the mapping.',
			},
			{
				id: 'mapper-node-click',
				selector: '[data-tour="mapper-node"]',
				content: 'Click on the node to bring up additional information.',
			},
			{
				id: 'node-properties',
				selector: '[data-tour="object-properties"]',
				content:
					'This is the config of the node item added to the mapper, it differs for each type and has its own separate tutorial.',
			},
			...(config.transformations[0].destinationMapping
				? [
						{
							id: 'destination-node',
							selector: '[data-tour="destination-node"]',
							content:
								'This is the destination node, this is where the configuartion will happen for the mapper.',
						},
						{
							id: 'destination-node-delete',
							selector: '[data-tour="destination-node-delete"]',
							content:
								'The nodes can also be removed by clicking on the "X" on the nodes themselves.',
						},
					]
				: []),
		];
	};

	return [
		{
			id: 'side-bar',
			selector: '[data-tour="side-bar"]',
			content:
				'The sidebar is used to navigate between the following menus:\n' +
				'* Object Properties - This tab has all populated Object properties shown and available for "Drag and Drop" to the Mapper Grid \n' +
				'* Node Info - This tab shows all binding information once a node has been selected - See Image Below\n' +
				'* Sample Result - This shows the sample result after mapping has been\n' +
				'* Error Panel - This panel is used to display any errors on the Mapper task.',
		},
		{
			id: 'mapper-grid',
			selector: '[data-tour="mapper-grid"]',
			content:
				'This is the grid where the Properties from the Object Properties can be dragged onto and the mappings can be configured and selected from here.',
		},
		{
			id: 'object-properties',
			selector: '[data-tour="object-properties"]',
			content:
				'The Object Properties tab is the landing tab once the task is opened.This tab is used to gain access to all object properties that gets extracted from the sample data. Properties can be dragged onto the mapper to start setting up the mapping. Try dragging a property to the diagram view.',
		},
		...getTransformationSteps(),
	].map(tourItem => ({ ...tourItem, styles: defaultStyles }));
}
